/**
 * @flow
 * @author: Vamsi Tallam
 */

import styled from 'react-emotion'

import { mobile, notMobile } from '../../../utils/mixins'
import CloudinaryS3Image from '../../CloudinaryS3Image'

export const MediaContainer = styled('div')``

export const LogoContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 90%;
  margin: auto;
  align-items: center;
  flex-wrap: wrap;
  max-width: 90em;
  margin-top: 40px;
  ${mobile} {
    display: none;
  }
`

export const LogoContainerMobile = styled('div')`
  ${notMobile} {
    display: none;
  }
  margin-bottom: 3.571em;
`

export const Logo = styled(CloudinaryS3Image)`
  ${mobile} {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
export const LogoLink = styled('a')`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 1.25em;
  margin-right: 1.25em;
  margin-bottom: 2.813em;
  ${mobile} {
    margin: 1.071em;
  }
`

export const SlickInnerDiv = styled('div')`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/components/IbcNews/NewsLogos/styledComponents.js